import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";

import {
  Divider,
  Paper,
  List,
  ListItem,
  ListItemText
} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  listItemText: {
    display: `flex`,
    justifyContent: `space-between`,
    width: `200px`,
    maxWidth: `95%`,
    margin: `0 ${theme.spacing(1.5)}px`
  },
  listItemSecondaryText: {
    display: `flex`,
    justifyContent: `space-between`,
    width: `200px`,
    maxWidth: `95%`,
    margin: `0 ${theme.spacing(1.5)}px`
  }
}));

const DifficultyList = ({ bounds, labels }) => {
  const classes = useStyles();

  return (
    <div>
      <Paper>
        <List aria-label="difficulty percentages">
          {labels.map(({ primary, secondary }, index) => {
            const upperBound = `${index ? `<` : ``}${_.round(
              bounds[index] * 100,
              0
            )}%`;
            const lowerBound = `${_.round(bounds[index + 1] * 100, 0)}%`;
            const primaryItem = (
              <div className={classes.listItemText}>
                <span>{primary}</span>
                <span>
                  {lowerBound} to {upperBound}
                </span>
              </div>
            );
            const secondaryItem = (
              <span className={classes.listItemSecondaryText}>{secondary}</span>
            );

            return (
              <Fragment key={primary}>
                <ListItem>
                  <ListItemText
                    primary={primaryItem}
                    secondary={secondaryItem}
                  />
                </ListItem>
                {index !== labels.length - 1 ? (
                  <Divider component="li" />
                ) : undefined}
              </Fragment>
            );
          })}
        </List>
      </Paper>
    </div>
  );
};

DifficultyList.defaultProps = {
  bounds: [],
  labels: []
};

export default DifficultyList;
